
import Master1 from '../components/newservice/Master1'

export default function AllPage() {
  return (
    <div>

       <Master1></Master1>
    </div>
  )
}
